<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-file-pdf-box</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.pdf') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 15px 0 15px;" />
      <!-- <span style="color:rgba(0, 0, 0, 0.54);">{{$t('menuType.pdf')}}</span> -->
      
      <!-- <v-file-input
        v-if="content.IsNew"
        v-model="file"
        display-size
        @change="handleChangePDFFile"
        style="margin-left: 15px"
        accept=".pdf" 
      />
      <v-text-field
        v-else
        v-model="content.URL"
        hideDetails
        :disabled="true"
        style="margin-left: 15px"
        @input="handleChangeIsModified"
      /> -->
    </v-toolbar>
    <translate
      v-model="content.URLPdfTranslate"
      :languages="languages"
      type="file"
      @input="handleChangeIsModified"
    />
    <v-layout
      wrap
    >
      <v-flex xs6>
        <v-checkbox
          v-model="content.PDFTranslateLink"
          :value="content.PDFTranslateLink"
          @change="handleChangeIsModified"
          :label="$t('common.openNewTab')"
        />
      </v-flex>
      <v-flex xs6 v-if="content.PDFTranslateLink && content.PDFTranslateLinkName" style="padding-right:15px;">
        <translate
          :label="$t('common.btnText')"
          v-model="content.PDFTranslateLinkName"
          :languages="languages"
          @input="handleChangeIsModified"
        />
      </v-flex>
    </v-layout>
    <v-checkbox
      v-model="content.DownloadPdfTranslate"
      :value="content.DownloadPdfTranslate"
      @change="handleChangeIsModified"
      :label="$t('common.download')"
    />
  </div>
</template>

<script>
  import api from '@/services/api'
  import Translate from '@/components/Translate'
  export default {
    components: {
      Translate
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      file: null
    }),
    computed: {
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      },
    }
  }
</script>

<style scoped>
</style>

